import React from 'react'
import { RouteComponentProps, StaticContext } from 'react-router'
import { withRouter } from 'react-router-dom'

class ScrollToTop extends React.Component<RouteComponentProps<any, StaticContext, any>> {
  public componentDidUpdate(prevProps) {
    // istanbul ignore else
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  public render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)
